import { render, staticRenderFns } from "./BarChart2.vue?vue&type=template&id=585153ce&"
import script from "./BarChart2.vue?vue&type=script&lang=js&"
export * from "./BarChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports